import axios from "axios";
import Cookies from "js-cookie";

const base_url = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
    baseURL: base_url,
    withCredentials: true,
});

// Add request interceptor to attach token
axiosInstance.interceptors.request.use(
    (config) => {
        const token = Cookies.get("access_token");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }

        if (!(config.data instanceof FormData)) {
            config.headers["Content-Type"] = "application/json";
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export default axiosInstance;
